@let model = introductionService.getModel()();

@if (model) {
    <ng-container *transloco="let t; prefix: 'uiIntroduction'">
        @if (model.heading) {
            <h1
                [class.mb-0]="model.publicationDate || model.publicationLocation"
                class="only:mb-0">
                {{ model.heading }}
                @if (model.headingAddition) {
                    <span
                        class="text-secondary"
                        [innerHTML]="model.headingAddition"></span>
                }
            </h1>
        }
        @if (model.publicationDate || model.publicationLocation) {
            <div class="mb-4 inline-block">
                <!-- eslint-disable-next-line @angular-eslint/template/conditional-complexity -->
                {{ (model.publicationLocation ?? '') + (model.publicationLocation && model.publicationDate ? ', ' : '') + ((model.publicationDate | date: 'dd.LL.yy') ?? '') }}
            </div>
        }
        @if (model.changed && model.readingTimeInMinutes) {
            <div class="my-4 flex flex-col gap-1 md:flex-row">
                <span class="block">{{ t('lastUpdate', { date: model.changed | date: 'dd. MMMM yyyy' }) }}</span>
                <span class="hidden md:block">|</span>
                <span class="block">{{ t('readingTime', { minutes: model.readingTimeInMinutes }) }}</span>
            </div>
        }
        @if (model.introduction) {
            <div
                class="text-primary text-lg dark:text-white"
                [innerHTML]="model.introduction | nl2br | sanitize: securityContext"></div>
        }
    </ng-container>
}
